import React, { useState } from 'react';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-leaf-soft py-5 sm:py-7" data-id="element-29" data-mp="1hd1nhy7fx7zi">
      <div className="mx-auto max-w-3xl px-4 sm:px-6" data-id="element-30" data-mp="1hdukw8kiel4z">
        <h2 className="text-center text-2xl leading-none text-forest sm:text-4xl" data-id="element-31" data-mp="1cf9lgbd305hl">
          Frequently asked <span className="text-leaf" data-id="element-32" data-mp="2a2iecrfewgtm">questions</span>
        </h2>

        <div className="mt-3 divide-y divide-forest/10 overflow-hidden rounded-lg border-2 border-forest bg-white" data-id="element-33" data-mp="2535qc3ct13pg">
          {faqs.map((faq, i) => {
          const isOpen = open === i;
          const Icon = isOpen ? MinusIcon : PlusIcon;
          return <div key={faq.question} data-id="element-34" data-mp="1v4pzm1hovwgh" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left transition-colors duration-150 ease-out hover:bg-leaf-soft" data-id="element-35" data-mp="oonpvjk9kdoh">
                  <span className="font-display text-sm font-semibold leading-tight text-forest sm:text-base" data-id="element-36" data-mp="1pkgwfypaw1ko">
                    {faq.question}
                  </span>
                  <Icon className="h-4 w-4 shrink-0 text-leaf" strokeWidth={3} aria-hidden="true" data-id="element-37" data-mp="1fn2ic5qunovj" />
                </button>
                {isOpen && <p id={`faq-${i}`} className="px-3 pb-2.5 text-sm leading-snug text-ink" data-id="element-38" data-mp="16oh3oloi0u01">
                    {faq.answer}
                  </p>}
              </div>;
        })}
        </div>
      </div>
    </section>;
}